<!-- Status eines Devices anzeigen -->
<template>
  <span v-if="deviceState">
    <b-alert
      :variant="variant"
      show
      :id="'traplinked-ergebnis-' + id"
      :style="
        'text-align:center;padding: 0rem 1rem;background-color:' +
        deviceState.alarm
      ">
      <b-icon :icon="deviceState.icon"></b-icon>&nbsp;
      <span v-html="result_value" v-if="result_value" />
      <span v-html="$t('message.deviceState_' + name)" v-else />
    </b-alert>
  </span>
</template>
<script>

import { AlarmLevel, getDeviceState } from '@/DeviceStates'

export default {
  name: 'DeviceStatus',
  props: [
    'value', // der deviceStatus
    'reportType',
    'eventType',
    'id',
    /** anstatt des Event Text oder Report Text muss hier das Result Value angezeigt werden, da es von einem Mitarbeiter so erfasst wurde */
    'result_value',
  ],
  data() {
    return {
      deviceState: null,
      variant: null,
      name: null,
    }
  },
  watch: {
    value: function () {
      this.init()
    },
    reportType: function () {
      this.init()
    },
    eventType: function () {
      this.init()
    },
    id: function () {
      this.init()
    },
    result_value: function () {
      this.init()
    },
  },
  created: function () {
    this.init()
  },
  methods: {

    init: function () {

      if (this.eventType) {
        this.deviceState = getDeviceState(this.eventType)
        this.name = this.eventType
      } else if (this.reportType) {
        this.deviceState = getDeviceState(this.reportType)
        this.name = this.reportType
      } else if (this.value) {
        this.deviceState = getDeviceState(this.value)
        this.name = this.value
      }

      // emit Text:
      if (this.result_value) {
        this.$emit('set-ergebnis-text', this.result_value)
      } else if (this.name) {
        this.$emit('set-ergebnis-text', this.name)
      }

      if (this.deviceState.alarm == AlarmLevel.GRUEN) {
        this.variant = 'success'
      } else if (this.deviceState.alarm == AlarmLevel.GELB) {
        this.variant = 'warning'
      } else if (this.deviceState.alarm == AlarmLevel.ROT) {
        this.variant = 'danger'
      }

    },

  }, // end methods

}

</script>